import React from 'react';
import { useAuth } from './useAuth';
import { Role } from './types';

type Props = {
  roles: Role[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

export const RequireRole: React.FC<Props> = ({ roles: requiredRoles, fallback, children }) => {
  const { loading, roles } = useAuth();
  const allowed = requiredRoles.some(role => roles.includes(role));

  if (loading) {
    return <div className="text-gray-300 text-sm">Checking access…</div>;
  }

  if (!allowed) {
    return <>{fallback ?? <div className="text-sm text-red-400">Not authorized</div>}</>;
  }

  return <>{children}</>;
};



